import { ModalsMapper, createModalsComponent } from 'modules/campaigns/lib';
import {
  CampaignIndexModalType,
  ModalProps,
  useCampaignIndexModalContext,
} from '../campaignFolders/contexts/CampaignIndexModalContext';
import { ConfirmDisableAlertsModal } from './ConfirmDisableAlertsModal';

const ALERTS_MODAL_COMPONENTS_MAPPER: ModalsMapper<CampaignIndexModalType, any> = {
  [CampaignIndexModalType.ConfirmDisableAlertsModal]: ConfirmDisableAlertsModal,
};

export const Modals = createModalsComponent<CampaignIndexModalType, ModalProps>(
  ALERTS_MODAL_COMPONENTS_MAPPER,
  useCampaignIndexModalContext,
);
